<template>
  <b-container>
    <div class="pb-lg-5 pt-lg-5">
      <b-row class="d-flex justify-content-center">
        <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
          <h2 class="text-center mb-3">Log in</h2>
          <b-form @submit.prevent="AuthenticateUser">
            <b-form-group class="text-left" id="input-group-1" label="Username" label-for="id_username">
              <b-form-input
                id="id_username"
                placeholder="Enter username"
                required
                type="text"
                v-model="form.username">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" id="input-group-2" label="Password" label-for="id_password">
              <b-form-input
                id="id_password"
                placeholder="Enter password"
                required
                type="password"
                v-model="form.password">
              </b-form-input>
            </b-form-group>

            <!-- not visible -->
            <div v-show="false">
              <b-form-group class="text-left" id="input-group-3" label="Email" label-for="id_email">
                <b-form-input
                  id="id_email"
                  placeholder="Enter email"
                  type="text"
                  v-model="form.email">
                </b-form-input>
              </b-form-group>
            </div>
            <b-row class="mt-4">
              <b-col>
                <g-signin-button
                  :params="googleSignInParams"
                  @success="onSignInSuccess"
                  @error="onSignInError"
                >
                  <i class="fab fa-google mr-3"></i>Google Login
                </g-signin-button>
              </b-col>
              <b-col class="d-flex justify-content-end">
                <b-button :to="{name: 'forgotPassword'}" class="btn mr-2" variant="outline-danger">Forgot Password</b-button>
                <b-button class="btn" type="submit" variant="primary">Log In</b-button>
              </b-col>
            </b-row>
          </b-form>

          <div class="mt-5 pt-5 text-center">
            <h2 class="mb-3">Not a member?</h2>
            <b-row class="mx-0">
              <b-button :to="{name: 'signup'}" class="btn" variant="info">Sign Up</b-button>
            </b-row>
          </div>
        </div>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import Footer from '../components/Footer'
import {mapGetters} from 'vuex'


export default {
  name: 'login',
  components: {
    Footer
  },
  data () {
    return {
      form: {
        username: '',
        email: '',
        password: ''
      },
      googleSignInParams: {
        client_id: '837325808921-dbdq54qf1qu3g9bv4athdovbb8a57t4o.apps.googleusercontent.com'
      },
      googleToken: ''
    }
  },
  created() {
    if(this.userFromComputed())
     this.showMsgLoggedIn();
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  },
  methods: {
    // onSignIn (googleUser) {
    //   let profile = googleUser.getBasicProfile()
    //   alert(profile.getEmail())
    //   console.log('ID: ' + profile.getId()) // Do not send to your backend! Use an ID token instead.
    //   console.log('Name: ' + profile.getName())
    //   console.log('Image URL: ' + profile.getImageUrl())
    //   console.log('Email: ' + profile.getEmail()) // This is null if the 'email' scope is not present.
    // },
    userFromComputed() {
          return this.authenticatedUser;
      },
    onSignInSuccess (googleUser) {
      const profile = googleUser.getBasicProfile()// etc etc
      console.log('Google TOKEN: ' + googleUser.getAuthResponse().id_token)
      this.googleToken = googleUser.getAuthResponse().id_token
      this.loginWithGoogle(this.googleToken)
    },
    loginWithGoogle (googleToken) {
      let credentials = {
        idtoken: googleToken
      }
      this.$store.dispatch('loginWithGoogle', credentials)
        .then(response => {
          if (response.status === 200) {
            this.$router.push({name: 'home'})
          } else {
          }
        }).catch((error) => {
          console.info(error)
          this.showMsgFail()
        })
    },
    onSignInError (error) {
      // `error` contains any error occurred.
      console.log('OH NOES', error)
    },
    showMsgLoggedIn (){
        this.$bvModal.msgBoxOk('You are already logged in', {
          okVariant: 'btn clbutton btn-secondary btn-sm'
        }) .then(value => {
          this.$router.push('/');
        })
        .catch(error => {

        })
    },
    showMsgFail () {
      this.boxOne = ''
      // if (error === 'Invalid login.') {
      this.$bvModal.msgBoxOk('Something went wrong. Please try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    AuthenticateUser (event) {
      let credentials = {
        login: this.form.username,
        password: this.form.password,
        email: this.form.email
      }
      this.$store.dispatch('login', credentials)
        .then(response => {
          if (response.status === 200) {
            this.$router.push({name: 'home'})
            // console.log('success')
          } else {
          }
        }).catch((error) => {
          console.info(error)
          this.showMsgFail()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .g-signin-button {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 3px;
    background-color: #3c82f7;
    color: #fff;
    &:hover {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue